import { render, staticRenderFns } from "./SubmitRecord.vue?vue&type=template&id=4491d81f&"
import script from "./SubmitRecord.vue?vue&type=script&lang=js&"
export * from "./SubmitRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports